import dayjs from 'dayjs';
import { formatTimeRangeToUtc } from '@/common/components/molecules/timeController/utils';

const TRIGGER_WINDOW_TO_OFFSET_SECONDS = 1;
const TRIGGER_WINDOW_LENGTH_MINUTES = 10;
const TRIGGER_WINDOW_PERIOD = 'p10m';

export const buildTriggerTimeWindow = (
  triggerTime: string | undefined | null,
): { fromTimeUtc: string; toTimeUtc: string; period: string } => {
  const now = dayjs.tz();

  const buildWindow = (toReference: dayjs.Dayjs) => {
    const fromTime = toReference
      .subtract(TRIGGER_WINDOW_LENGTH_MINUTES, 'minute')
      .format('YYYY-MM-DD HH:mm:ss');
    const toTime = toReference.format('YYYY-MM-DD HH:mm:ss');
    return {
      ...formatTimeRangeToUtc({ fromTime, toTime }),
      period: TRIGGER_WINDOW_PERIOD,
    };
  };

  if (typeof triggerTime !== 'string' || triggerTime.length === 0) return buildWindow(now);
  if (!dayjs(triggerTime).isValid()) return buildWindow(now);

  const toCandidate = dayjs.tz(triggerTime).add(TRIGGER_WINDOW_TO_OFFSET_SECONDS, 'second');
  if (toCandidate.isAfter(now)) return buildWindow(now);

  return buildWindow(toCandidate);
};
